// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__37YpB","selects":"Documents_selects__28nL6"};